import { Tooltip, Typography } from "@mui/material"
import { formatFullMoney, formatLargeNumber, isLargeNumber } from "../format-utils"

export function CostFigure({
    value,
    currencySymbol,
    variant = "body2",
    color,
    fontWeight,
    sx,
    noWrap,
    showPlus,
    suffix = "",
    dataCy,
}) {
    const numericValue = Number(value) || 0
    const compactValue = `${formatCompactValue()}${suffix}`
    const fullValue = `${formatFullMoney(numericValue, currencySymbol, { showPlus })}${suffix}`
    const showTooltip = isLargeNumber(numericValue)

    return (
        <Tooltip
            title={fullValue}
            arrow
            disableHoverListener={!showTooltip}
            disableFocusListener={!showTooltip}
            disableTouchListener={!showTooltip}
        >
            <Typography
                data-cy={dataCy}
                variant={variant}
                color={color}
                fontWeight={fontWeight}
                noWrap={noWrap}
                sx={sx}
            >
                {compactValue}
            </Typography>
        </Tooltip>
    )

    function formatCompactValue() {
        if (showPlus && numericValue > 0) return `+${formatLargeNumber(numericValue, currencySymbol)}`
        return formatLargeNumber(numericValue, currencySymbol)
    }
}
